export const getDurationLabel = (days: number): string => {
  const MONTH_DAYS = 30;
  const WEEK_DAYS = 7;

  if (days >= MONTH_DAYS) {
    return '{count} month{count, plural, one {} other {s}}';
  }

  if (days >= WEEK_DAYS) {
    return '{count} week{count, plural, one {} other {s}}';
  }

  return '{count} day{count, plural, one {} other {s}}';
};

export const getUTCEpochFromLocalDate = (date: Date): number => {
  // Local epoch millis
  const localMillis = date.getTime();

  // Timezone offset in minutes (positive if behind UTC, e.g., IST = -330)
  const offsetMinutes = date.getTimezoneOffset();

  return localMillis + offsetMinutes * 60 * 1000;
};
